<style scoped>
    * {
        font-family: PingFangSC-Regular, PingFang SC;
    }
</style>
<template>
    <div class="main" @click="uploadApp">
        <div style="width: 100%;">
            <img style="width: 100%;" src="../../assets/img/mixed/loveplay_upload.jpg">
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {};
        },
        created() {
            this.util.title("下载");
            this.uploadApp();
        },
        methods: {
            uploadApp() {
                window.location.href = "https://thread.tcjhz.com/package/forlove/forlove.apk"
            }
        },
    };
</script>
